import React from 'react';
import { BookOpen } from 'lucide-react';
import { eCodeDatabase } from '../utils/database';
import { getStatusStyles } from '../utils/halalAnalysis';
import { useTranslation } from 'react-i18next';

export default function ECodeList() {
  const { t } = useTranslation();
  const groupedCodes = {
    haram: [],
    halal: [],
    doubtful: []
  };

  Object.entries(eCodeDatabase).forEach(([code, info]) => {
    if (groupedCodes[info.status]) {
      groupedCodes[info.status].push([code, info]);
    }
  });

  const sectionConfig = [
    { key: 'haram', title: t('ecodes.haramSectionTitle', { defaultValue: 'Haram E-Codes' }) },
    { key: 'halal', title: t('ecodes.halalSectionTitle', { defaultValue: 'Halal E-Codes' }) },
    { key: 'doubtful', title: t('ecodes.doubtfulSectionTitle', { defaultValue: 'Doubtful E-Codes' }) }
  ];

  return (
    <div style={{ padding: '16px' }}>
      <h2 style={{ 
        fontSize: '24px', 
        fontWeight: 'bold', 
        color: 'var(--text-primary)', 
        marginBottom: '20px', 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        margin: '0 0 20px 0'
      }}>
        <BookOpen size={28} /> {t('ecodes.title')}
      </h2>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        {sectionConfig.map((section) => {
          const sectionItems = groupedCodes[section.key] || [];
          if (sectionItems.length === 0) return null;

          return (
            <div key={section.key} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--text-primary)', margin: 0 }}>
                {section.title}
              </h3>

              {sectionItems.map(([code, info]) => {
                const styles = getStatusStyles(info.status);
                return (
                  <div
                    key={code}
                    style={{
                      padding: '16px',
                      border: '1px solid var(--border-color)',
                      borderRadius: '12px',
                      backgroundColor: 'var(--bg-card)'
                    }}
                  >
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'start',
                      gap: '12px'
                    }}>
                      <div style={{ flex: 1 }}>
                        <h3 style={{
                          fontSize: '18px',
                          fontWeight: 'bold',
                          color: 'var(--text-primary)',
                          marginBottom: '4px',
                          margin: '0 0 4px 0'
                        }}>
                          {code}
                        </h3>
                        <p style={{
                          fontSize: '16px',
                          color: 'var(--text-secondary)',
                          marginBottom: '6px',
                          margin: '0 0 6px 0'
                        }}>
                          {info.nameKey ? t(info.nameKey) : info.name}
                        </p>
                        <p style={{ fontSize: '14px', color: 'var(--text-tertiary)', marginBottom: '4px', margin: '0 0 4px 0' }}>
                          <strong>{t('ecodes.sourceLabel')}</strong> {info.sourceKey ? t(info.sourceKey) : info.source}
                        </p>
                        <p style={{ fontSize: '14px', color: 'var(--text-tertiary)', margin: 0 }}>
                          ⚠️ {info.concernKey ? t(info.concernKey) : info.concern}
                        </p>
                      </div>
                      <span style={{
                        padding: '6px 16px',
                        borderRadius: '12px',
                        fontSize: '13px',
                        fontWeight: '600',
                        backgroundColor: styles.bg,
                        color: styles.color,
                        whiteSpace: 'nowrap'
                      }}>
                        {styles.text}
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      
      <div style={{ 
        marginTop: '24px', 
        padding: '16px', 
        background: 'var(--warning-bg)', 
        borderRadius: '12px' 
      }}>
        <h3 style={{ fontWeight: 'bold', color: 'var(--warning-title)', marginBottom: '8px', margin: '0 0 8px 0' }}>
          {t('ecodes.importantNoteTitle')}
        </h3>
        <p style={{ fontSize: '14px', color: 'var(--warning-text)', margin: 0 }}>
          {t('ecodes.importantNoteBody')}
        </p>
      </div>
    </div>
  );
}